import styled from '@emotion/styled';

export const ChannelTalkButton = styled.button<{
  bottom: number;
}>`
  border: none;
  background-color: transparent;
  position: fixed;
  bottom: calc(env(safe-area-inset-bottom) + 96px);
  right: 16px;
  cursor: pointer;
  z-index: 19;

  @media (min-width: 1200px) {
    bottom: 20px;
    right: 20px;
  }
`;

export const PcImage = styled.img`
  display: none;
  width: 145px;
  height: 68px;

  @media (min-width: 1200px) {
    display: block;
  }
`;

export const MobileImage = styled.img`
  display: block;
  width: 56px;
  height: 56px;

  @media (min-width: 1200px) {
    display: none;
  }
`;
